export const ADD_SPACE = "ADD_SPACE";
export const UPDATE_SPACE = "UPDATE_SPACE";
